import { workOrders } from "../../../data/workOrders";
import Summerybox from "../../../components/Summerybox";
import PageHeading from "../../../components/PageHeading";
import { worksummery } from "../../../data/worksummery";
import { useEffect, useState } from "react";
import AddWorkOrderPopUp from "./AddWorkOrderPopUp";
import SideMessage from "../../../components/SideMessage";
import DeleteWorkOrder from "../../../APIs/WorkOrder/DeleteWorkOrder";
import GetWorkOrder from "../../../APIs/WorkOrder/GetWorkOrder";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";
import FilterTable from "../../../components/FilterTable";
const WorkOrder = () => {
  //     const filteredVendors = vendors.filter((vendor) =>
  //     vendor.name.toLowerCase().includes("").toLowerCase()
  //   );
  const navigate = useNavigate()
  let [showModal, setShowModal] = useState(0)
  const [searchTerm, setSearchTerm] = useState("");
  // const [editData, setEditData] = useState([]);
  // const [isEdit, setIsEdit] = useState(0);
  const [workOrderList, setWorkOrderList] = useState([])
  const [workOrderTempList, setWorkOrderTempList] = useState([])
  const [isShowLoader, setIsShowLoader] = useState(0)
  // const filteredWorkOrders = workOrders.filter((vendor) =>
  //   vendor.vendorname.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   vendor.projectName.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const [sideToster, setSideToster] = useState({
    show: 0,
    message: '',
    type: ''
  })


  const getWorkOrder = async () => {
    try {
      setIsShowLoader(1);
      let purchaseorder = await GetWorkOrder()
      if (purchaseorder.status === 1) {
        setWorkOrderList(purchaseorder.responseValue);
        setWorkOrderTempList(purchaseorder.responseValue);
        setIsShowLoader(0);
      }
      else {
        setSideToster({
          message: purchaseorder.responseValue,
          show: 1,
          type: 'alert'
        })
        setIsShowLoader(0);
      }
    }
    catch (error) {
      setSideToster({
        message: error.message,
        show: 1,
        type: 'alert'
      })
      setIsShowLoader(0);
    }

  }
  const handleUpdate = (val) => {
    navigate('/addworkorder/' + val.id)
    // setEditData(val)
    // setIsEdit(1)
    // setShowModal(1)
  }

  let handleDelete = async (rowId) => {
    setIsShowLoader(1);
    const response = await DeleteWorkOrder(rowId);
    if (response.status === 1) {
      setIsShowLoader(0);
      setSideToster({
        message: 'Data Deleted',
        show: 1,
        type: 'Success'
      })
      getWorkOrder();
    }
    else {
      setIsShowLoader(0);
      setSideToster({
        show: 1,
        message: response.responseValue,
        type: 'Alert'
      })
    }
  }

  useEffect(() => {
    if (showModal === 0) {
      getWorkOrder();
    }
  }, [showModal])
  return (
    <div>

      <div className='row pb-3'>
        <div className="flex-grow-1">
          <div className="container-fluid p-4">
            <div className='container-fluid landformconatiner p-4' style={{ maxHeight: "420px" }}>
              <div className='d-flex flex-column flex-md-row justify-content-between pe-3 ps-3 pb-3'>

                <PageHeading pagename="Work Order" />
                {/* <button className="bg-#00AFF0" type="button" class="btn btn-primary" onClick={() => { setShowModal(1) }}>+ Add Work Order</button> */}
                <button className="btn btn-primary" type="button" onClick={() => { navigate("/addworkorder/") }}>+ Add Work Order</button>
              </div>

              <div className='expenses-conatiner' style={{ columnGap: "25px" }}>
                <Summerybox
                  color="#006CFF"
                  // width="300px"
                  title="Remaining Work"
                  works={worksummery.remaining.works}
                  vendors={worksummery.remaining.vendors}
                  amountCr={worksummery.remaining.amountCr}
                />
                <Summerybox
                  color="#03D4C6"
                  // width="300px"
                  title="Completed Work"
                  works={worksummery.completed.works}
                  vendors={worksummery.completed.vendors}
                  amountCr={worksummery.completed.amountCr}
                />
                <Summerybox
                  color="#FE996C"
                  // width="300px"
                  title="In Progress Work"
                  works={worksummery.inProgress.works}
                  vendors={worksummery.inProgress.vendors}
                  amountCr={worksummery.inProgress.amountCr}
                />

              </div>
            </div>

            {/* TABLE */}
            <div className="container-fluid landformconatiner p-4 mt-3">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <PageHeading pagename="Vendor List" />
                <FilterTable tempList={workOrderTempList} tempListMethod={setWorkOrderTempList} originalList={workOrderList} isSearch={true} isdate={false} isFilter={false} isExport={true} />
              </div>
              <table className="table">
                <thead>
                  <tr className="table-head">
                    <th>Expense</th>
                    <th>Project</th>
                    <th>Vendor</th>
                    <th>Amount</th>
                    <th>Time Period</th>
                    <th>Time Period Unit</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {workOrderTempList && workOrderTempList.map((work, ind) => (
                    <tr key={work.id} style={{ cursor: "pointer" }}>
                      <td>{work.expenseName}</td>
                      <td>{work.projectName}</td>
                      <td>{work.vendorName}</td>
                      <td>₹ {work.amount}</td>
                      <td>{work.timePeriod}</td>
                      <td>{work.timePeriodUnit === 1 ? "Days" : work.timePeriodUnit === 2 ? "Weeks" : "Years"}</td>
                      <td>
                        <div class="dropdown dropend">
                          <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                          <ul className="dropdown-menu mr-3">
                            <li>
                              <span className="dropdown-item" onClick={() => { handleUpdate(work) }}>Edit</span>
                            </li>
                            <li>
                              <span className="dropdown-item" onClick={() => { handleDelete(work.id); }}>Delete</span>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
            {/* <div className="pt-4">

              <div className="d-flex justify-content-between align-items-center mb-4">
                <PageHeading pagename="Vendor List" />
                <input
                  type="text"
                  className="form-control ms-auto"
                  placeholder="Search Vendor"
                  style={{ width: "300px" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}

                />
              </div>

              <table className="table">
                <thead>
                  <tr className="table-head">
                    <th>Vendor/Company</th>
                    <th>Project</th>
                    <th>Work Status</th>
                    <th>Remaining Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredWorkOrders.map((vendor) => (
                    <tr key={vendor.id} style={{ cursor: "pointer" }}>
                      <td>{vendor.vendorname}</td>
                      <td>{vendor.projectName}</td>
                      <td>
                        <span className="text-success fw-bold">
                          {vendor.workstatus.completed} ↑
                        </span>
                        <span className="text-danger fw-bold ms-3">
                          {vendor.workstatus.inProgress} ↓
                        </span>
                        <span className="text-secondary fw-bold ms-3">
                          {vendor.workstatus.remaining}
                        </span>
                      </td>
                      <td>₹ {vendor.remainingAmount}</td>
                    </tr>
                  ))}
                </tbody>

              </table>

            
            </div> */}
          </div>
        </div>
      </div>


      {/* {
        showModal ?
          <AddWorkOrderPopUp showModal={showModal} closeModal={setShowModal} editData={editData} setEditData={setEditData} isEdit={isEdit} setIsEdit={setIsEdit} /> : ""
      } */}
      {
        sideToster.show === 1 ?
          <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
          : ""
      }
      {
        <Loader show={isShowLoader} />
      }
    </div>
  );
};

export default WorkOrder;